import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gl0015',
    ecrans: ['00-2']
});

